import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PwaProvider } from "@/context/PwaContext";
import { Layout } from "@/components/Layout";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import WisdomPath from "@/pages/WisdomPath";
import { AuthPage, ForgotPassword } from "@/pages/Auth";
import { BrowseIssues, BrowseAll } from "@/pages/Browse";
import { DailyProverb, DownloadLibrary } from "@/pages/Content";
import { Favorites, Journal, SavedWisdom } from "@/pages/UserSpace";
import { Account, Pricing } from "@/pages/Account";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import ShareLanding from "@/pages/ShareLanding";
import Harborstone from "@/pages/Harborstone";
import Unsubscribe from "@/pages/Unsubscribe";
import SendWisdom from "@/pages/SendWisdom";
import ConfirmWisdom from "@/pages/ConfirmWisdom";
import { ShareCards, ShareCardsSuccess } from "@/pages/ShareCards";
import PersonalGuidance from "@/pages/PersonalGuidance";
import Sponsor from "@/pages/Sponsor";
import { About, Contact, ScriptureInfo, Privacy, Terms } from "@/pages/Static";
import { Admin } from "@/pages/Admin";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="py-32 text-center text-[#94A3B8]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PwaProvider>
          <ScrollToTop />
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wisdom-path" element={<WisdomPath />} />
            <Route path="/wisdom/:slug/:id" element={<ShareLanding />} />
            <Route path="/harborstone" element={<Harborstone />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/send" element={<SendWisdom />} />
            <Route path="/confirm-wisdom" element={<ConfirmWisdom />} />
            <Route path="/cards" element={<ShareCards />} />
            <Route path="/cards/success" element={<ShareCardsSuccess />} />
            <Route path="/guidance" element={<PersonalGuidance />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/saved" element={<Protected><SavedWisdom /></Protected>} />
            <Route path="/browse-issues" element={<BrowseIssues />} />
            <Route path="/browse-all" element={<BrowseAll />} />
            <Route path="/daily" element={<DailyProverb />} />
            <Route path="/library" element={<DownloadLibrary />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/scripture-info" element={<ScriptureInfo />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/favorites" element={<Protected><Favorites /></Protected>} />
            <Route path="/journal" element={<Protected><Journal /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Layout>
        </PwaProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
